import React, { ReactNode } from 'react';
import TcImage from './TcImage';

// Helper function to safely convert any value to a string
const getSafeString = (value: any): string => {
    if (typeof value === 'string') {
        return value;
    }
    
    if (value && typeof value === 'object') {
        // Handle API error objects
        if (value.message && typeof value.message === 'string') {
            return value.message;
        }
        
        // Log warning for debugging
        console.warn('⚠️ TcCard received object instead of string:', value);
        
        // Fallback for unknown error objects
        return value.toString ? value.toString() : '';
    }
    
    if (value === null || value === undefined) {
        return '';
    }
    
    // Convert any other type to string
    return String(value);
};

function TcCard({
    classNameStyle = "", 
    cardTitle = "", 
    cardContent = "",
    cardImage = "",
    children = null
}: {
    readonly classNameStyle?: string;
    readonly cardTitle?: string | any;
    readonly cardContent?: string | any;
    readonly cardImage?: string;
    readonly children?: ReactNode;
}) {
    // Ensure all content is safely converted to strings
    const safeCardTitle = getSafeString(cardTitle);
    const safeCardContent = getSafeString(cardContent);
    
    return (
        <div className={`relative px-8 py-4 mx-auto max-w-xl w-full h-auto ${classNameStyle}`}>
            {safeCardTitle && 
            <h2
                className="mt-1 mb-4 leading-7"
                dangerouslySetInnerHTML={{ __html: safeCardTitle }}
            />}

            {safeCardContent && 
            <div className="min-h-10">
                <p
                    className="text-xl leading-tight"
                    dangerouslySetInnerHTML={{ __html: safeCardContent }}
                />
            </div>}

            {cardImage && 
            <TcImage classNameStyle="mt-6">
                <img src={cardImage} alt={safeCardTitle} />
            </TcImage>}

            {children}
        </div>
    )
}

export default TcCard;